// Reconciles the crew form's UI field shape with the backend's UpsertCrewRequest/CrewController payload shape.

// The backend returns working-hour times as 'H:i:s' (e.g. '12:00:00'), but
// the time picker works in 'H:i' — trim the seconds for display.
function toShortTime (value) {
  return value ? String(value).slice(0, 5) : null
}

export function crewDataFetched (event) {
  const { data: apiData, updateData } = event || {}
  const data = apiData?.data || {}

  updateData({
    status_id: data?.status?.name ?? null,
    base_geolocation_id: data?.base_geolocation?.id ?? null,
    vehicle_id: data?.vehicle?.id ?? null,
    responsible_person_id: data?.responsible_person?.person_id ?? null,
    crew_members: data?.members || [],
    working_hours: (data?.working_hours || []).map((day) => ({
      day: (day?.day_of_week ?? 1) - 1,
      enabled: !!day?.is_active,
      from: toShortTime(day?.work_start),
      to: toShortTime(day?.work_end),
      break_from: toShortTime(day?.break_start),
      break_to: toShortTime(day?.break_end)
    }))
  })
}

export function crewModifyDataBeforeSend (event) {
  const { originalData } = event || {}

  if (!originalData) {
    return originalData
  }

  const { crew_members: crewMembers, working_hours: workingHours, responsible_person_id: responsiblePersonId, status_id: statusId } = originalData

  originalData.status_name = statusId ?? null
  delete originalData.status_id

  originalData.member_ids = (crewMembers || [])
    .map((member) => member?.person_id)
    .filter((personId) => personId && personId !== responsiblePersonId)
  delete originalData.crew_members

  originalData.working_hours = (workingHours || []).map((day) => ({
    day_of_week: (day?.day ?? 0) + 1,
    is_active: !!day?.enabled,
    work_start: day?.from || null,
    work_end: day?.to || null,
    break_start: day?.break_from || null,
    break_end: day?.break_to || null
  }))

  return originalData
}
